"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Componentlinkedin = function Componentlinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    color: props.color
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M21.01 1H2.99C1.891 1 1 1.891 1 2.99v18.02C1 22.109 1.891 23 2.99 23h18.02c1.099 0 1.99-.891 1.99-1.99V2.99C23 1.891 22.109 1 21.01 1ZM7.808 19.996c0 .32-.26.58-.58.58H4.764a.58.58 0 0 1-.579-.58V9.662c0-.32.26-.58.58-.58h2.465c.32 0 .579.26.579.58v10.334ZM5.996 8.11a2.342 2.342 0 1 1 0-4.684 2.342 2.342 0 0 1 0 4.684Zm14.695 11.934a.533.533 0 0 1-.532.532h-2.646a.532.532 0 0 1-.532-.532v-4.848c0-.723.212-3.168-1.89-3.168-1.63 0-1.961 1.674-2.027 2.425v5.59a.532.532 0 0 1-.533.533H9.972a.533.533 0 0 1-.532-.532V9.615c0-.294.238-.532.532-.532h2.56c.293 0 .531.238.531.532v.902c.605-.907 1.503-1.608 3.416-1.608 4.236 0 4.212 3.958 4.212 6.132v5.002Z"
  }));
};
Componentlinkedin.defaultProps = {
  color: "#FF7A00"
};
var _default = Componentlinkedin;
exports["default"] = _default;